import React from "react";
import styled from "styled-components";
import { Render } from "../services/renders-api";
import RendersCarousel from "./RendersCarousel";

interface RendersBottomBarProps {
  renders: Render[];
  loading?: boolean;
  error?: string | null;
  selectedRenderId?: string;
  onRenderSelect?: (render: Render) => void;
}

/**
 * Renders Bottom Bar Component
 * 
 * A simplified bottom bar for the UserFolderPage that displays only the renders carousel.
 * No configuration options (color selector, dropdown menu, state buttons).
 */
const RendersBottomBar: React.FC<RendersBottomBarProps> = ({
  renders,
  loading = false,
  error = null,
  selectedRenderId,
  onRenderSelect,
}) => {
  return (
    <Container>
      <TopContainer>
        <TitleSection>
          <Title>Vos rendus</Title>
          {!loading && !error && (
            <RenderCount>
              {renders.length} rendu{renders.length !== 1 ? 's' : ''}
            </RenderCount>
          )}
        </TitleSection>
        
        {error ? (
          <ErrorMessage>{error}</ErrorMessage>
        ) : (
          <RendersCarousel
            renders={renders}
            loading={loading}
            selectedRenderId={selectedRenderId}
            onRenderSelect={onRenderSelect}
          />
        )}
      </TopContainer>
    </Container>
  );
};

// Styled components
const Container = styled.div`
  display: flex;
  background-color: white;
  padding: 10px 20px;
  min-height: 8rem;
  text-align: center;
  flex-direction: column;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  // position:fixed;
  // width:100%;
  // bottom:0%;
  // opacity: 1;

  @media (max-width: ${props => props.theme.breakpoints.lg}) {
    padding: 2vh 4vw;
    min-height: 5rem;
  }
`;

const TopContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 100px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const RenderCount = styled.span`
  font-size: 0.75rem;
  color: #666;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const ErrorMessage = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dc3545;
  font-size: 0.9rem;
  padding: 1rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export default RendersBottomBar;
